import $ from 'jquery'

$('.hero-services__back, .hero-links__item--services').on('click', function () {
  $('.hero-services').toggle()
})

$('.hero .mouse').on('click', function () {
  $('html, body').animate(
    {
      scrollTop: $('.entry-content--main').offset().top,
    },
    500
  )
})
